import ApiSync from '../api/ApiSync';
import { APIResponseStatus } from '../Interfaces';

export interface FormResponseData extends APIResponseStatus {
  message: string;
}

class Search {
  public form: HTMLFormElement;
  private searchInput: HTMLInputElement;
  private resultsContainer: HTMLElement;
  private api: ApiSync;
  private debounceTimer: ReturnType<typeof setTimeout>;

  constructor(formSselector: string | HTMLFormElement) {
    if (typeof formSselector === 'string') {
      this.form = document.querySelector(formSselector);
    } else {
      this.form = formSselector;
    }

    if (this.form) {
      this.resultsContainer = this.form.querySelector('.js-search-results');
      this.searchInput = this.form.querySelector('.js-search-input');

      this.initEventsListeners();
      this.initApi();
    }
  }

  private initEventsListeners(): void {
    if (this.searchInput) {
      this.searchInput.addEventListener('keyup', this.onSearch.bind(this));
    }

    this.form.addEventListener('reset', () => {
      this.searchInput.focus();
      this.resetForm();
    });
  }

  private onSearch(e: Event): void {
    const { value } = e.target as HTMLInputElement;

    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      if (value.length > 2) this.onFormSubmit(value);
      if (value.length === 0) this.resetForm();
    }, 500);
  }

  private initApi(): void {
    const { requestUrl } = this.form.dataset;
    this.api = new ApiSync(requestUrl);
  }

  private async onFormSubmit(q: string): Promise<void> {
    this.form.classList.add('form--show-reset');
    //  fetch data from api
    try {
      const responseData = await this.api.fetch<FormResponseData>({
        query: q
      });
      if (responseData?.status)
        this.resultsContainer.innerHTML = responseData.message;
    } catch (error) {
      this.resultsContainer.innerHTML = error;
    }
  }

  private resetForm(): void {
    this.resultsContainer.innerHTML = '';
    this.form.reset();
    this.form.classList.remove('form--show-reset');
  }
}

export default Search;
